import Image from 'next/legacy/image';
import React, { FC } from 'react';
import { Box, Flex } from '@rebass/grid';
import Title from '@oberoninternal/travelbase-ds/components/primitive/Title';
import { FormattedMessage, useIntl } from 'react-intl';
import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import styled from 'styled-components';
import Link from './Link';
import { useRouter } from 'next/router';

const imageUrl = {
    nl: '/static/img/promo-nl.png',
    de: '/static/img/promo-de.png',
    en: '/static/img/promo-en.png',
};

const Promo: FC<React.PropsWithChildren<unknown>> = () => {
    const { formatMessage } = useIntl();

    const { locale } = useRouter();

    return (
        <Container
            my={[6, 8]}
            pt={[6, 8]}
            flexDirection={['column', null, 'row']}
            justifyContent="space-around"
            alignItems="center"
        >
            <StyledBoxImage width={[1, 1, 1, 1 / 2]} mb={[0, 0, 6, 0]}>
                <Image
                    loading="lazy"
                    src={imageUrl[(locale ?? 'nl') as keyof typeof imageUrl]}
                    alt={formatMessage({ defaultMessage: 'Texel Paspoort' })}
                    layout="responsive"
                    width={674}
                    height={403}
                />
            </StyledBoxImage>
            <Box mt={[5, null, 0]} width={[1 / 1, 1 / 1, 1 / 1, 1 / 2]} ml={[0, 0, 0, 7]}>
                <Title variant="large">
                    <FormattedMessage defaultMessage="De Kaart van Texel cadeau bij je boeking" />
                </Title>
                <StyledBox mt={[2, null, 5]}>
                    <Body variant="regular">
                        <FormattedMessage defaultMessage="Boek je jouw verblijf via VVV Texel? Dan profiteer je van persoonlijke service van echte Texelkenners én draag je bij aan een sterke toekomst voor het eiland." />
                    </Body>
                    <Body variant="regular">
                        <FormattedMessage
                            defaultMessage="Tijdelijk ontvang je bovendien de gloednieuwe Kaart van Texel cadeau bij je boeking via {texelLink} . Deze complete kaart met wegen, fietspaden en dorpsplattegronden kun je tijdens je verblijf ophalen in de winkel van VVV Texel. Je ontvangt één kaart per boeking."
                            values={{
                                texelLink: (
                                    <Link href="http://www.texel.net">
                                        <a>texel.net</a>
                                    </Link>
                                ),
                            }}
                        />
                    </Body>
                </StyledBox>
            </Box>
        </Container>
    );
};

const Container = styled(Flex)`
    border-top: 1px solid ${({ theme }) => theme.colors.neutral[20]};
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.m}) {
        flex-direction: row;
    }

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.xl}) {
        align-items: center;
    }
`;
const StyledBox = styled(Box)`
    p {
        margin-bottom: 0.8rem;
        @media screen and (min-width: ${({ theme }) => theme.mediaQueries.xl}) {
            margin-bottom: 1.6rem;
        }
    }
`;

const StyledBoxImage = styled(Box)`
    position: relative;
    cursor: pointer;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.primary['20']};
`;
export default Promo;
